// ============ スムーススクロールモジュール ============
class SmoothScroll {
  constructor(options = {}) {
    // sticky-headerの高さを動的に取得
    const stickyHeader = document.querySelector('sticky-header');
    const defaultOffset = stickyHeader ? stickyHeader.offsetHeight : 0;
    
    this.options = {
      selector: 'a[href^="#"]',
      behavior: 'smooth',
      block: 'start',
      offset: defaultOffset,
      ...options
    };
    this.init();
  }

  init() {
    document.querySelectorAll(this.options.selector).forEach(anchor => {
      anchor.addEventListener('click', (e) => this.handleClick(e, anchor));
    });
  }

  handleClick(e, anchor) {
    const href = anchor.getAttribute('href');
    
    // ハッシュのみの場合はスキップ
    if (href === '#') return;
    
    const target = document.querySelector(href);
    if (target) {
      e.preventDefault();
      this.scrollToTarget(target);
    }
  }

  scrollToTarget(target) {
    // sticky-headerの高さを毎回取得（リサイズ対応）
    const stickyHeader = document.querySelector('sticky-header');
    const currentOffset = this.options.offset || (stickyHeader ? stickyHeader.offsetHeight : 0);
    
    const targetPosition = target.getBoundingClientRect().top + window.pageYOffset;
    const offsetPosition = targetPosition - currentOffset;

    window.scrollTo({
      top: offsetPosition,
      behavior: this.options.behavior
    });
  }

  // 動的に追加された要素にもスムーススクロールを適用
  refresh() {
    this.init();
  }
}

// ============ 外部リンク自動別タブ対応モジュール ============
class ExternalLinkHandler {
  constructor(options = {}) {
    this.options = {
      selector: 'a[href]',
      excludeSelectors: [
        '[target]', // 既にtarget属性が設定されているもの
        '[data-no-external]' // 明示的に除外したいもの
      ],
      ...options
    };
    this.currentDomain = window.location.hostname;
    this.init();
  }

  init() {
    this.applyToLinks();
    
    // 動的に追加される要素にも対応
    this.observeDOMChanges();
  }

  applyToLinks() {
    const links = document.querySelectorAll(this.options.selector);
    
    links.forEach(link => {
      // 除外条件チェック
      if (this.shouldExclude(link)) return;
      
      // 外部リンク判定
      if (this.isExternalLink(link)) {
        this.makeExternal(link);
      }
    });
  }

  shouldExclude(link) {
    return this.options.excludeSelectors.some(selector => {
      if (selector.startsWith('[')) {
        // 属性セレクタの場合
        const attr = selector.slice(1, -1).split('=')[0];
        return link.hasAttribute(attr);
      }
      return link.matches(selector);
    });
  }

  isExternalLink(link) {
    const href = link.getAttribute('href');
    
    // 空のhrefやアンカーリンクはスキップ
    if (!href || href.startsWith('#') || href.startsWith('javascript:')) {
      return false;
    }
    
    // 相対パスは内部リンク
    if (href.startsWith('/') || href.startsWith('./') || href.startsWith('../')) {
      return false;
    }
    
    // メールリンクや電話リンクはスキップ
    if (href.startsWith('mailto:') || href.startsWith('tel:')) {
      return false;
    }
    
    // 絶対URLの場合、ドメインをチェック
    try {
      const linkURL = new URL(href, window.location.origin);
      return linkURL.hostname !== this.currentDomain;
    } catch (e) {
      // URLのパースに失敗した場合は内部リンクとして扱う
      return false;
    }
  }

  makeExternal(link) {
    link.setAttribute('target', '_blank');
    link.setAttribute('rel', 'noopener noreferrer');
    
    // アクセシビリティのため、aria-labelがない場合は追加
    if (!link.hasAttribute('aria-label')) {
      const currentLabel = link.getAttribute('aria-label') || link.textContent.trim();
      link.setAttribute('aria-label', `${currentLabel}（新規タブ）`);
    }
  }

  observeDOMChanges() {
    // MutationObserverで動的に追加される要素を監視
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === 1) { // Element node
            // 追加されたノード自体がリンクの場合
            if (node.tagName === 'A') {
              if (!this.shouldExclude(node) && this.isExternalLink(node)) {
                this.makeExternal(node);
              }
            }
            // 追加されたノード内のリンクを処理
            const links = node.querySelectorAll?.(this.options.selector);
            links?.forEach(link => {
              if (!this.shouldExclude(link) && this.isExternalLink(link)) {
                this.makeExternal(link);
              }
            });
          }
        });
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  // 手動で再適用したい場合
  refresh() {
    this.applyToLinks();
  }
}

document.addEventListener('DOMContentLoaded', function() {
  window.smoothScroll = new SmoothScroll();
  window.externalLinkHandler = new ExternalLinkHandler();
});